import React from "react";

import Chart from "react-apexcharts";

import { barChartConfig, CHART_COLORS } from "../../../utils/chartConfigs";
import EmptyState from "../shared/EmptyState";

/**
 * Grouped bar chart comparing new customers vs churned.
 *
 * @param {{
 *   newCustomers: number[],
 *   churned: number[],
 *   categories: string[],
 *   height?: number
 * }} props
 */
const CustomerGrowthChart = ({ newCustomers, churned, categories, height }) => {
  const hasData =
    (newCustomers && newCustomers.length > 0) ||
    (churned && churned.length > 0);

  if (!hasData) {
    return <EmptyState message="No customer growth data available" />;
  }

  const series = [
    { name: "New Customers", data: newCustomers || [] },
    { name: "Churned", data: churned || [] },
  ];

  const config = barChartConfig(series, categories, {
    colors: [CHART_COLORS.primary, CHART_COLORS.gray],
  });

  // Ensure NOT stacked (grouped bars)
  config.chart = {
    ...config.chart,
    stacked: false,
  };

  // Legend top-right
  config.legend = {
    position: "top",
    horizontalAlign: "right",
    fontSize: "13px",
    markers: { radius: 3 },
    itemMargin: { horizontal: 12 },
  };

  // Override Y-axis formatter to plain numbers (not currency)
  config.yaxis = {
    ...config.yaxis,
    labels: {
      ...config.yaxis?.labels,
      formatter: (val) => {
        if (val >= 1_000) return `${(val / 1_000).toFixed(1)}k`;

        return String(val);
      },
    },
  };

  // Override data-label formatter to plain numbers
  config.dataLabels = {
    ...config.dataLabels,
    formatter: (val) => {
      if (val >= 1_000) return `${(val / 1_000).toFixed(1)}k`;

      return val;
    },
  };

  // Override tooltip formatter to plain numbers
  config.tooltip = {
    ...config.tooltip,
    y: {
      formatter: (val) => `${Number(val).toLocaleString()} customers`,
    },
  };

  // Separate series from options
  const { series: _series, ...options } = config;

  return (
    <Chart
      height={height || 350}
      options={options}
      series={series}
      type="bar"
    />
  );
};

export default CustomerGrowthChart;
